<template>
  <div class="templateManage">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">合同模板管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <el-select v-model="filters.assetType" clearable size="small" class="long-select" placeholder="请选择资产类型">
              <el-option
                v-for="item in assetTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain class="query" @click="search(1)">查询</el-button>
            <el-button size="small" type="info" plain @click="resetSearch">重置</el-button>
            <el-button
              size="small"
              type="info"
              plain
              class="add"
              style="background:#FF812D;color:#fff;border-color:#FF812D"
              v-if="edit"
              @click="openDialog()"
            >新增</el-button>
          </div>
        </div>
      </div>

      <div class="table-container">
        <el-table :data="list" style="width:100%" size="medium">
          <i slot="empty" style="font-style:normal">暂无数据</i>
          <el-table-column prop="templateName" label="模板名称" align="center" min-width="180" show-overflow-tooltip />
          <el-table-column label="资产类型" align="center" width="140">
            <template slot-scope="scope">{{ enumLabel("assetType", scope.row.assetType) }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template slot-scope="scope">
              <span class="content-edit" v-if="edit" @click="openDialog(scope.row)">编辑</span>
              <span class="content-del" v-if="edit" @click="onDelete(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="860px"
      custom-class="lease-ylw-dialog"
      :close-on-click-modal="false"
      append-to-body
      @close="resetDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="资产类型" prop="assetType">
          <el-select
            v-model="form.assetType"
            placeholder="请选择"
            style="width:100%"
            @change="onAssetTypeChange"
          >
            <el-option
              v-for="item in assetTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="isAssetTypeOccupied(item.value)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="form.templateName" maxlength="100" placeholder="自动生成，可修改" />
        </el-form-item>
        <el-form-item label="模板内容" prop="content">
          <lease-rich-editor v-model="form.content" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixins from "@/common/MixIn.js";
import PageChange from "@/components/common/PageChange.vue";
import LeaseRichEditor from "@/components/fishPondLease/common/LeaseRichEditor.vue";
import {
  pageTemplate,
  getTemplate,
  addTemplate,
  editTemplate,
  deleteTemplate,
  leaseRequestError
} from "@/service/fishPondLease";
import {
  AssetTypeOptions,
  enumLabel
} from "@/service/fishPondLeaseEnums";

export default {
  name: "TemplateManage",
  mixins: [mixins],
  components: { PageChange, LeaseRichEditor },
  data() {
    return {
      list: [],
      filters: {
        assetType: null
      },
      assetTypeOptions: AssetTypeOptions,
      pageInfo: {
        pageNumber: 1,
        totalPages: 0,
        pageFunc: this.search,
        pageSize: 10
      },
      dialogVisible: false,
      saving: false,
      editingId: null,
      occupiedTemplates: [],
      form: {
        assetType: 1,
        templateName: "",
        content: ""
      },
      rules: {
        assetType: [
          { required: true, message: "请选择资产类型", trigger: "change" },
          { validator: this.validateAssetTypeUnique, trigger: "change" }
        ],
        templateName: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入模板内容", trigger: "blur" }]
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.editingId ? "编辑合同模板" : "新增合同模板";
    }
  },
  async mounted() {
    await this.initPagePermission();
    this.search(1);
  },
  methods: {
    enumLabel,
    assetTypeLabel(value) {
      return enumLabel("assetType", value) || "";
    },
    autoTemplateName(assetType) {
      return this.assetTypeLabel(assetType) + "合同模板";
    },
    isAssetTypeOccupied(assetType) {
      return this.occupiedTemplates.some(
        t =>
          Number(t.assetType) === Number(assetType) &&
          String(t.id) !== String(this.editingId || "")
      );
    },
    firstAvailableAssetType() {
      const item = this.assetTypeOptions.find(opt => !this.isAssetTypeOccupied(opt.value));
      return item ? item.value : null;
    },
    validateAssetTypeUnique(rule, value, callback) {
      if (value && this.isAssetTypeOccupied(value)) {
        callback(new Error("当前企业下该资产类型已存在合同模板，每种资产类型只能维护一条"));
        return;
      }
      callback();
    },
    loadOccupied() {
      return pageTemplate({ pageIndex: 1, pageSize: 100 }).then(res => {
        const data = (res && res.data) || {};
        const list = data.list || [];
        const currentId = this.curCompany && this.curCompany.id;
        this.occupiedTemplates = currentId
          ? list.filter(t => String(t.enterpriseId) === String(currentId))
          : list;
      });
    },
    search(pageNum) {
      const pageIndex = pageNum || this.pageInfo.pageNumber || 1;
      this.pageInfo.pageNumber = pageIndex;
      const params = {
        pageIndex: pageIndex,
        pageSize: this.pageInfo.pageSize,
        assetType:
          this.filters.assetType === null || this.filters.assetType === ""
            ? undefined
            : this.filters.assetType
      };
      pageTemplate(params)
        .then(res => {
          const data = (res && res.data) || {};
          this.list = data.list || [];
          this.pageInfo.totalPages = data.total || 0;
        })
        .catch(err => {
          this.$message.error(leaseRequestError(err));
        });
    },
    resetSearch() {
      this.filters = { assetType: null };
      this.search(1);
    },
    openDialog(row) {
      this.loadOccupied()
        .then(() => {
          if (row && row.id) {
            this.editingId = row.id;
            this.dialogVisible = true;
            return getTemplate(row.id).then(res => {
              const d = (res && res.data) || row;
              this.form = {
                assetType: d.assetType,
                templateName: d.templateName || this.autoTemplateName(d.assetType),
                content: d.content || ""
              };
              this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
              });
            });
          }
          this.editingId = null;
          const assetType = this.firstAvailableAssetType();
          if (assetType == null) {
            this.$message.warning("当前企业下每种资产类型已各有一条合同模板，无法再新增");
            return;
          }
          this.form = {
            assetType: assetType,
            templateName: this.autoTemplateName(assetType),
            content: ""
          };
          this.dialogVisible = true;
          this.$nextTick(() => {
            if (this.$refs.form) this.$refs.form.clearValidate();
          });
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error(leaseRequestError(err));
          this.dialogVisible = false;
        });
    },
    resetDialog() {
      this.editingId = null;
      this.saving = false;
    },
    onAssetTypeChange(val) {
      this.form.templateName = this.autoTemplateName(val);
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.saving = true;
        const payload = {
          assetType: this.form.assetType,
          templateName: this.form.templateName,
          content: this.form.content
        };
        const req = this.editingId
          ? editTemplate(Object.assign({}, payload, { id: this.editingId }))
          : addTemplate(payload);
        req
          .then(() => {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.search(this.pageInfo.pageNumber);
          })
          .catch(err => {
            this.$message.error(leaseRequestError(err));
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    onDelete(row) {
      this.$confirm("确认删除该模板？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => deleteTemplate(row.id))
        .then(() => {
          this.$message.success("删除成功");
          this.search(this.pageInfo.pageNumber);
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error(leaseRequestError(err));
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.templateManage .content-container .titieMian .select-container
  margin-top -5px
.content-edit
  color #3389ff
  cursor pointer
  margin 0 6px
.content-del
  color #f56c6c
  cursor pointer
  margin 0 6px
</style>
